const getCardReducer = (state = { cardState: (localStorage.getItem("cardState") ? JSON.parse(localStorage.getItem("cardState")) : "")}, action) => {
    switch (action.type) {
        case "CARD_STATE":
            return {
                cardState: action.cardState
            }
        default:
            return state
    }
}

export default getCardReducer;


// WEBPACK FOOTER //
// ./src/reducer/getcardreducer.jsx